// extracted by mini-css-extract-plugin
module.exports = {"reveal":"HeaderTextAnimation_reveal__cZQKE","hidden":"HeaderTextAnimation_hidden__7uWP5"};